import { Box, Button, Paper, Stack, Typography } from "@mui/material";
import { forwardRef } from "react";
import { ColumnMappingModalTriggerProps } from "../DataImport.interfaces";
import { isManualMappingStatus } from "../helpers/DataInporter.helpers";

export const ColumnMappingModalTrigger = forwardRef<HTMLButtonElement, ColumnMappingModalTriggerProps>(function ColumnMappingModalTrigger(
  { entityName, mappings, errorsCount, requiredFieldsWithoutMappingCount, hasManualMappedColumns, hasMappingProblems, ...buttonProps },
  ref,
) {
  const mappedColumnsCount = mappings.filter((mapping) => mapping.csvHeaders && mapping.csvHeaders.length > 0).length;

  const manualColumnsCount = mappings.filter((mapping) => {
    return mapping.csvHeaders && mapping.csvHeaders.length > 0 && isManualMappingStatus(mapping.matchedBy);
  }).length;

  return (
    <Paper
      elevation={0}
      sx={{
        p: 1.5,
        border: "1px solid",
        borderColor: hasMappingProblems ? "error.light" : hasManualMappedColumns ? "warning.light" : "success.light",
        borderRadius: 1.5,
        bgcolor: hasMappingProblems ? "rgba(211, 47, 47, 0.04)" : hasManualMappedColumns ? "rgba(237, 108, 2, 0.04)" : "rgba(46, 125, 50, 0.04)",
      }}
    >
      <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5} alignItems={{ xs: "stretch", sm: "center" }} justifyContent="space-between">
        <Box>
          <Typography variant="body2" fontWeight={700}>
            {hasMappingProblems ? "Column mapping needs attention" : hasManualMappedColumns ? "Manual mapping review" : "Column mapping ready"}
          </Typography>

          <Typography variant="caption" color="text.secondary">
            {hasMappingProblems
              ? `${errorsCount} validation error(s), ${requiredFieldsWithoutMappingCount} missing required mapping(s).`
              : hasManualMappedColumns
                ? `${manualColumnsCount} manually mapped column(s) should be reviewed.`
                : `${mappedColumnsCount} ${entityName} column(s) mapped.`}
          </Typography>
        </Box>

        <Button
          {...buttonProps}
          ref={ref}
          variant={hasMappingProblems || hasManualMappedColumns ? "contained" : "outlined"}
          color={hasMappingProblems ? "error" : hasManualMappedColumns ? "warning" : "primary"}
          size="small"
          sx={{
            textTransform: "none",
            borderRadius: 1.5,
            ...buttonProps.sx,
          }}
        >
          {hasMappingProblems ? "Open Mapping" : hasManualMappedColumns ? "Review Mapping" : "View Mapping"}
        </Button>
      </Stack>
    </Paper>
  );
});
